import React, { useState, useEffect } from 'react'
import { useSearchParams} from "react-router-dom";

import { DataGrid } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import { Grid, Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

import DeleteNotification from '../../core/components/DeleteNotification';
import {CoreContext} from "../../core/context/CoreContext";
import PageWaiting from '../../core/components/PageWaiting';
import {isMobile} from 'react-device-detect';

import {getListAPI, deleteAPI} from './StockorderAPI';
import {getColumns} from './StockorderStruct';
import ListCardView from '../../core/components/card/ListCardView';
import ListTableView from '../../core/components/card/ListTableView';

import {getStockorderView} from './StockorderView';
import CardListLayout from '../../core/components/card/layout/CardListLayout';
import { useSelector, useDispatch } from 'react-redux';
import {setViewParams} from '../../store/slice/ChoiceSelectionSlice';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';

import {setFilter} from '../../store/slice/ConfSlice';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import MyPageContainer from '../../core/template/MyPageContainer';
import { deleteStockorderObj  ,setSelectedStockorderId,setStockorderAddStockOrderModal,setSelectedActionId , 
  setShowEditForStockorder, setStockorderManageStockOrderModal,setStockorderPrintStockOrderModal} from 'store/slice/ManufSlice';

import StockorderListTable from './components/StockorderListTable';
import { useNavigate } from "react-router-dom";
import { setClickedBo,setActionClicked } from 'store/slice/BreadCrumSlice';
import StockorderFilterCriteria from './StockorderFilterCriteria';

import AddCardIcon from '@mui/icons-material/AddCard';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

import AddStockOrderActionModal from './action/AddStockOrder/AddStockOrderActionModal';
import ManageStockOrderActionModal from './action/ManageStockOrder/ManageStockOrderActionModal';
import PrintStockOrderActionModal from './action/PrintStockOrder/PrintStockOrderActionModal';

import { transformDateValue } from 'core/js/FormUtils';

export default function StockorderListImpl( {tableList, cardList, setShowEdit, setStockorderId}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setNotification, setShowLoading, showloading, lastURL } = React.useContext(CoreContext);
  const columns = getColumns(editCallBack, initDeleteCallBack);
  const [view, setView] = useState(1);
  const { showfilter } = useSelector((state) => state.confslice)

  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const {selectedId, stockorderObj} = useSelector((state)=>state.manufslice.stockorderDashboard);
  const { stockorderList } = useSelector((state) => state.manufslice.stockorderDashboard);

  useEffect(() => {
  }, [stockorderList, stockorderObj])
  
  function initDeleteCallBack(id){
    dispatch(setSelectedStockorderId(id));
    setShowDeleteAlert(true);
  }
  function deleteCallBack(obj){
    dispatch(deleteStockorderObj(obj.id));
    setNotification('Record deleted successfully !!!')
  }
  function deleteRecord(){
    deleteAPI(selectedId,deleteCallBack);
    setShowDeleteAlert(false);
  }

  function editCallBack(id){
    dispatch(setSelectedStockorderId(id));
    dispatch(setShowEditForStockorder(true));
  }
  
  const createStockorder=()=>{
    dispatch(setSelectedStockorderId(-1));
    //dispatch(setShowEditForStockorder(true));
    dispatch(setStockorderAddStockOrderModal(true));
  }


  const AddStockOrderCallBack = (id) =>{
    dispatch(setSelectedStockorderId(id));
    dispatch(setStockorderAddStockOrderModal(true));
  }
  const ManageStockOrderCallBack = (id) =>{
      dispatch(setSelectedStockorderId(id));
      dispatch(setStockorderManageStockOrderModal(true));
    }
  const PrintStockOrderCallBack = (id) =>{
      dispatch(setSelectedStockorderId(id));
      dispatch(setStockorderPrintStockOrderModal(true));
    }

const getDataWithDateTransformation = (data) =>{
    let newData = {
      ...data,
      'expand':false,

    }
    return newData;
  }
  const stockorderTransformation = (tableList) =>{
    let newDataList=[]
    tableList.map((data)=>{ 
      newDataList.push(getDataWithDateTransformation(data));
     })
    return newDataList;
  }

  const payload = {
    stockorderList:stockorderList,
    cardList:getStockorderView(tableList),
        actionList: [
          /*{title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'NA'},
          {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
          
        {id:94, title:'Add Stock Order', callBackMethod:AddStockOrderCallBack, icon:<AddCardIcon/>, status:'Draft', role:''},
        */
        ],
        dialogueActionList: [
          
        ],
    tableView:{
      tableList:stockorderTransformation(tableList),
      stockorderList:stockorderList,
      actionList:[
        {title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'NA'},
        {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
        
        {id:94, title:'Add Stock Order', callBackMethod:AddStockOrderCallBack, icon:<AddCardIcon/>, status:'Draft', role:''},
        {id:96, title:'Manage Stock Order', callBackMethod:ManageStockOrderCallBack, icon:<AppRegistrationIcon/>, status:'NA', role:''},
        {id:98, title:'Print Stock Order', callBackMethod:PrintStockOrderCallBack, icon:<PictureAsPdfIcon/>, status:'Draft', role:''},
      ]
    }
  }
  
  const getPayload = ()=>{
    return payload;
  }

  useEffect(()=>{
    if (document.body.offsetWidth<500)  setView(0);
    dispatch(setViewParams({
      colsCount:{xs:12, sm:4, md:4, lg:4},
      modal:{
            
      }
      }))
  },[])

  return (
   <>
   {showloading?<PageWaiting/>:
      <Grid container direction="column">
              <Grid item>
                  <Grid container direction="row" justifyContent={'space-between'} alignContent={'center'} sx={{height:showfilter?'55px':'35px'}}>
                      <Grid item  lg={3}>
                        <Typography variant='h4' color="primary.darker">Stock Order</Typography>
                      </Grid>
                      <Grid item lg={8}>
                      {showfilter ?  < StockorderFilterCriteria  />: <></>}
                      </Grid>
                      <Grid item lg={1}>
                        <Grid container justifyContent={'flex-end'}>
                        {/* {showfilter?
                            <Grid item>
                              <Tooltip title="Hide filter" sx={{cursor: "pointer"}}>
                                <FilterAltOffIcon onClick={()=>{dispatch(setFilter(false))}}/>
                              </Tooltip>
                            </Grid>
                            :
                            <Grid item>
                              <Tooltip title="Show filter" sx={{cursor: "pointer"}}>
                                <FilterAltIcon onClick={()=>{dispatch(setFilter(true))}}/>
                              </Tooltip>
                            </Grid>
                            } */}
                            {/*view===1?
                            <Grid item>
                              <Tooltip title="Grid View" sx={{cursor: "pointer"}}>
                                <ViewWeekIcon onClick={()=>{setView(0)}}/>
                              </Tooltip>
                            </Grid>
                            :
                            <Grid item>
                              <Tooltip title="Table View" sx={{cursor: "pointer"}}>
                                <CalendarViewMonthIcon onClick={()=>{setView(1)}}/>
                              </Tooltip>
                            </Grid>
                            */}
                            <Grid item>
                              <Tooltip title="Add Stockorder" sx={{cursor: "pointer"}}>
                                <AddIcon onClick={()=>{createStockorder()}}/>
                              </Tooltip>
                            </Grid>
                          </Grid>
                      </Grid>
                      
                  </Grid>
              </Grid>
              <Grid item>
                < StockorderListTable 
                  payload={getPayload().tableView}
                  />
                  
              </Grid>     
      </Grid>
   }
    { showDeleteAlert?<DeleteNotification 
            id={selectedId}
            width="50%"
            setShowDeleteAlert={setShowDeleteAlert}
            deleteRecord = {deleteRecord}/>: ''
    }

    
<AddStockOrderActionModal/>
<ManageStockOrderActionModal/>
<PrintStockOrderActionModal/>
    </>
);


}